/*
  Caviére delivery promise (Feature 4)
  Works out, in Dallas (Central) time, when an order placed right now ships
  and when it arrives, then fills in every [data-cav-arrival] line on the page.

  Rules (edited in Customize > Theme settings > Caviére delivery promise):
  - Ships Monday to Thursday, same day if ordered before the cutoff hour.
  - Priority Overnight, so it arrives the next day.
  - Never ships on a listed holiday, or the day before one (it would arrive on the holiday).

  No ticking timer: the line refreshes once a minute so it stays true after the cutoff.
  Plain JavaScript, no libraries. About 3 KB.
*/
(function () {
  if (window.__caviereArrival) return;
  window.__caviereArrival = true;

  var TIME_ZONE = 'America/Chicago';
  var DAY = 864e5;

  function nowInDallas(now) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    })
      .formatToParts(now || new Date())
      .forEach(function (p) {
        parts[p.type] = p.value;
      });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      hour: (+parts.hour % 24) + +parts.minute / 60
    };
  }

  function isoDay(date) {
    return date.toISOString().slice(0, 10);
  }

  function addDays(date, n) {
    return new Date(date.getTime() + n * DAY);
  }

  function longDay(date) {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      weekday: 'long',
      month: 'short',
      day: 'numeric'
    }).format(date);
  }

  // Pure function so it can be tested: returns { shipsToday, ship, arrival, today }.
  function plan(now, cutoffHour, holidays) {
    var dallas = nowInDallas(now);
    var today = dallas.date;
    var isHoliday = function (date) {
      return holidays.indexOf(isoDay(date)) > -1;
    };
    var canShip = function (date) {
      var weekday = date.getUTCDay(); // 1 = Monday ... 4 = Thursday
      return weekday >= 1 && weekday <= 4 && !isHoliday(date) && !isHoliday(addDays(date, 1));
    };

    var ship = today;
    if (!(canShip(today) && dallas.hour < cutoffHour)) {
      ship = addDays(today, 1);
      for (var i = 0; i < 30 && !canShip(ship); i++) ship = addDays(ship, 1);
    }
    return { today: today, ship: ship, arrival: addDays(ship, 1), shipsToday: isoDay(ship) === isoDay(today) };
  }

  function relative(date, today) {
    var diff = Math.round((date - today) / DAY);
    if (diff === 0) return 'today';
    if (diff === 1) return 'tomorrow';
    return longDay(date);
  }

  function render(el) {
    var target = el.querySelector('[data-cav-arrival-text]');
    if (!target) return;

    var cutoff = parseFloat(el.getAttribute('data-cutoff-hour')) || 12;
    var holidays = (el.getAttribute('data-holidays') || '').split(/[\s,]+/).filter(Boolean);
    var result = plan(new Date(), cutoff, holidays);

    var template = el.getAttribute(result.shipsToday ? 'data-msg-today' : 'data-msg-later') || '';
    var text = template
      .replace('[cutoff]', el.getAttribute('data-cutoff-label') || 'noon CT')
      .replace('[ship]', relative(result.ship, result.today));
    var arrivalText = relative(result.arrival, result.today);

    // Build the sentence with the arrival day in bold, without using innerHTML.
    var pieces = text.split('[arrival]');
    target.textContent = '';
    pieces.forEach(function (piece, index) {
      target.appendChild(document.createTextNode(piece));
      if (index < pieces.length - 1) {
        var strong = document.createElement('strong');
        strong.textContent = arrivalText;
        target.appendChild(strong);
      }
    });
    el.setAttribute('data-ready', 'true');
  }

  function renderAll() {
    document.querySelectorAll('[data-cav-arrival]').forEach(render);
  }

  var pending;
  function renderSoon() {
    clearTimeout(pending);
    pending = setTimeout(renderAll, 80);
  }

  window.CaviereArrival = { plan: plan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }
  // The cart drawer redraws itself after every change, so fill in any new lines.
  if ('MutationObserver' in window) {
    // Only react to new delivery lines, never to the text this script writes itself.
    var hasNewLine = function (node) {
      if (node.nodeType !== 1) return false;
      if (node.matches('[data-cav-arrival]:not([data-ready])')) return true;
      return !!node.querySelector('[data-cav-arrival]:not([data-ready])');
    };
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (hasNewLine(added[j])) {
            renderSoon();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  setInterval(renderAll, 60000);
})();